// src/pages/Publications.jsx
import { publications } from '../models/portfolioData';

export default function Publications() {
  return (
    <section className="section" id="publications">
      <div className="container text-center">
        <p className="section-subtitle">What I Published ?</p>
        <h6 className="section-title mb-6">Publications</h6>

        {/* Publications Cards Container */}
        <div className="max-w-4xl mx-auto space-y-6">
          {publications.map((pub) => (
            <div key={pub.id} className="blog-card">
              <div className="blog-card-body w-full">
                <h5 className="blog-card-title">{pub.title}</h5>

                <div className="blog-card-caption">
                  <span>By: Ismail Jabiulla</span>
                  <span>
                    <i className="ti-bookmark text-primary mr-1"></i> {pub.publication}
                  </span>
                  <span>
                    <i className="ti-calendar text-primary mr-1"></i> {pub.date}
                  </span>
                </div>

                <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 leading-relaxed">
                  {pub.description}
                </p>

                {/* Tags */}
                <div className="flex flex-wrap gap-1.5 mb-2">
                  {pub.tags.map((tag) => (
                    <span
                      key={tag}
                      className="bg-gray-100 dark:bg-[#232334] text-gray-600 dark:text-gray-400 text-xs px-2.5 py-0.5 rounded border border-gray-200 dark:border-[#2b2b3d]"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>

                {pub.link && (
                  <a
                    href={pub.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="blog-card-link"
                  >
                    Read more <i className="ti-angle-double-right"></i>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
